/**
 * /tenants/{slug}/admins/invite — tenant-scoped admin invite.
 *
 * Reuses the shared InviteAdminPage, locked to this tenant: only
 * tenant-scoped roles are offered and the invite POSTs to the tenant's
 * admin-users endpoint. Loader prefetches the RBAC catalog so the role
 * dropdown paints without a spinner (immutable per deploy → cached for
 * the session).
 */

import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { InviteAdminPage } from "@/features/platform-admins/pages/invite-admin-page";
import { fetchRBACCatalog } from "@/features/platform-admins/rbac-queries";
import { queryKeys } from "@/lib/query-keys";

function TenantInviteAdminPage() {
  const { tenant } = Route.useRouteContext();
  const { slug } = Route.useParams();
  const navigate = useNavigate();
  return (
    <InviteAdminPage
      lockedTenant={{ id: tenant.id, slug, name: tenant.name }}
      adminsHref={`/tenants/${slug}/admins`}
      onNavigateToList={() =>
        void navigate({ to: "/tenants/$slug/admins", params: { slug } })
      }
    />
  );
}

export const Route = createFileRoute("/_authed/tenants/$slug/admins/invite")({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.rbacCatalog,
      queryFn: fetchRBACCatalog,
      staleTime: Infinity,
    }),
  component: TenantInviteAdminPage,
});
